import { CallbackWrap } from '@/types/common'
import { Embed } from '@/types/embed'
import { LevelingEmbed, LevelingTabDefinition } from '@/types/leveling'
import { faEdit } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { RichTextEditor } from 'components/editor/rich-text-editor/RichTextEditor'
import { Widget } from 'leveling/widget'
import React from 'react'
import './custom-tab.scss'

export function CustomTab({
  embed,
  tabsAttr,
  tabIndex,
  onEmbedChange,
  isActiveTab
}: {
  embed: LevelingEmbed
  tabsAttr: 'tabs' | 'extraTabs'
  tabIndex: number
  onEmbedChange?: (value: CallbackWrap<Embed>) => void
  isActiveTab?: boolean
}) {
  const [isEditingContent, setIsEditingContent] = React.useState(false)

  const onAttrInTabChange = <K extends keyof LevelingTabDefinition>(
    newValue: LevelingTabDefinition[K],
    attr: K
  ) =>
    onEmbedChange?.((embed) => {
      if (embed.type !== 'leveling') return embed
      if (!embed[tabsAttr]?.[tabIndex]) return embed
      embed = { ...embed }
      embed[tabsAttr] = embed[tabsAttr]!.slice()
      embed[tabsAttr]![tabIndex] = {
        ...embed[tabsAttr]![tabIndex],
        [attr]: newValue
      }
      return embed
    })

  return (
    <Widget
      className="poe-custom-tab"
      title={embed?.[tabsAttr]?.[tabIndex].name}>
      <div className="poe-custom-tab-content">
        {!!onEmbedChange && (
          <span>
            {isEditingContent ? (
              <button onClick={() => setIsEditingContent(false)}>Close</button>
            ) : (
              <FontAwesomeIcon
                icon={faEdit}
                onClick={() => {
                  setIsEditingContent(true)
                }}
              />
            )}
          </span>
        )}

        <RichTextEditor
          render={true}
          key={`${embed.id}-${tabsAttr}-${tabIndex}-content`}
          value={embed[tabsAttr]?.[tabIndex]?.content}
          isEditing={isEditingContent}
          onChange={
            onEmbedChange
              ? (newValue) => {
                  onAttrInTabChange(newValue, 'content')
                }
              : undefined
          }
        />
      </div>
    </Widget>
  )
}
